import { Box } from '@mui/material'
import React from 'react'
import CustomText from '../CustomText/CustomText'
import { colors } from 'styles/colors';

const LABEL_SIZE = '14px';

interface Props {
  label?: string;
  note?: string;
  required?: boolean;
}

export default function CustomLabel({ label, note, required }: Props) {
  return (
    <Box>
      {label && (
        <Box display='flex' flexDirection='row' alignItems='center' mb={'5px'}>
          <CustomText text={label} fontSize={LABEL_SIZE} fontWeight={600} color={colors.primary} />

          {note && (
            <Box ml={'2px'}>
              <CustomText
                text={note}
                fontSize={LABEL_SIZE}
                color={colors.pureBorder}
                fontWeight={500}
              />
            </Box>
          )}
          {required === true && (
            <CustomText text="*" fontSize={LABEL_SIZE} color={colors.error} fontWeight={600} />
          )}
          {required === false && (
            <Box ml={'2px'}>
              <CustomText
                text="(Optional)"
                fontSize={LABEL_SIZE}
                color={colors.secondary}
                fontWeight={500}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
